import {UnavailableImageNames} from "@/enums/unavaibleImageNames";

export const imageMixin = {
  computed: {},
  methods: {
    getImageURL(imageCode, large = false) {
      if (!imageCode) {
        return large ? UnavailableImageNames.LARGE_IMG : '/UnavailableSmall.png'
      }
      return this.$config.axios.browserBaseURL + 'images/' + imageCode
    },
  },
}
